import { moduleApi, resourceOf } from '@pray/shared/utils/api';

import type { RefreshAction, RefreshPage } from './refreshTypes';
import { decodeRefreshPage, encodeRefreshAction } from './refreshWire';

const REFRESH = '/api/studio/v1/segments/refresh';

/**
 * The segment refresh as the page shows it: the job's last status, the admins' controls and the re-seed requests,
 * each with the version a write over it sends back. Needs `manage_segment_refresh`, which only the studio wildcard
 * holds, so anyone else gets a 403.
 */
export async function getSegmentRefresh(): Promise<RefreshPage> {
  return resourceOf(await moduleApi.get(REFRESH), decodeRefreshPage);
}

/**
 * One admin act, answered with the page as it stands after it. A `version` that is no longer the stored one is a 409
 * `conflict`; an act the refresh refuses is a 422 whose first error carries the refusal's sentence; a 503 means
 * nothing was written, or, when its detail says the change may have been written, that the page must be read again.
 */
export async function applyRefreshAction(action: RefreshAction): Promise<RefreshPage> {
  const { path, body } = encodeRefreshAction(action);

  return resourceOf(await moduleApi.post(path, body), decodeRefreshPage);
}
